export default "__VITE_ASSET__ulcRo5Wt__"